import { Grid, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { SwitchListActionsProps } from './props';
import { SWITCH_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const SwitchListActions = ({ id }: SwitchListActionsProps) => {
    const navigate = useNavigate();
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${SWITCH_EDIT}/${id}`);
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
